<template>
  <div>
    <button @click="$router.push('dashboard')" :style="isMobile() ? 'margin-left:80px;' : ''" tabindex="-1" substrate="button" class="wizard-btn noprint" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
      <span style="padding-right: 4px;">←</span> Back to Dashboard
    </button>

    <ModalIdle v-if="isIdle" />

    <div style="margin-top: 25px;">
      <img :src="this.logo" alt="logo" height="60">
      <span style="padding-left: 10px; font-size:23px; color:black;">Flexo Craft Prints</span>
      <br v-if="isMobile()">
      <br v-if="isMobile()">
      <div :style="(isMobile()) ? '' : 'display: flex; justify-content: space-between;' " style="">
        <div>
          <p style="line-height: 4px; margin-top: 10px;">1000 First St</p>
          <p style="line-height: 4px;">Harrison, NJ 07029</p>
          <p style="line-height: 4px;">FlexoCraft.com</p>
          <p style="line-height: 4px;">Phone: 800-785-2737</p>
          <p style="line-height: 4px;">Email: info@flexcraft.com</p>
        </div>

        <br v-if="isMobile()">

        <div style="border: 1px solid black; padding-left: 5px; padding-right: 5px;">
          <p style="line-height: 2px; margin-top: 10px; padding-top: 2px; padding-bottom: 10px; border-bottom: 1px solid black;">DATE: {{ currentDate }}</p>
          <p style="line-height: 2px; padding-bottom: 10px; border-bottom: 1px solid black;">QUOTE #: {{ quoteId }}</p>
          <p style="line-height: 2px; padding-bottom: 12px; border-bottom: 1px solid black;">VALID UNTIL: {{ validUntil }}</p>
          <p style="line-height: 2px;">FOB: NJ/CA</p>
          <!--<p style="line-height: 0px;">CASE PACK: {{ casePackAmount ? casePackAmount : '' }}</p>-->
        </div>
      </div>

      <br v-if="isMobile()">
      <br v-if="isMobile()">

      <div :style="(isMobile()) ? '' : 'width: 400px;' " style="background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">CUSTOMER</div>
      <p style="font-size:18px; color: black; padding-top: 2px;">{{ userData.fullName }}</p>

      <div style="margin-bottom: 25px;"></div>

      <div :style="(isMobile()) ? '' : 'width: 400px;' " style="background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">PRINT NAME</div>
      <p style="font-size:18px; color: black; padding-top: 2px;">{{ printName }}</p>

      <div style="margin-bottom: 25px;"></div>
    <!--</div>-->
    <br>

    <div v-if="customQuote" style="font-size: 20px; text-align: center; color: green;">
      <i><b>Thank you for your quote. A quote representative will reach out with a quote within 48 hours.</b></i>
    </div>

    <br><br><br>
    <!--
    <div style="color: white; background-color: black;">
    <p v-if="this.quote" style="font-weight: bold; font-size: 50px; padding-top: 30px;">${{ (this.quote * this.selectedQuantity).toLocaleString('en-US') }}</p>
    <p v-else style="font-weight: bold; font-size: 50px; padding-top: 30px;">Thank You!</p>
    <p v-if="this.quote" style="padding-top:5px;">${{ this.quote }} per piece</p>
    <p v-else style="padding-top:5px;">Your quote will be emailed to you shortly.</p>
    </div>
    -->
    <div v-for="(quantArr, index) in displayItems">
      <div style="background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold; margin-top: 25px;">
        QUANTITY {{ index }}
      </div>
      <table v-if="!isMobile()" style="width: 100%;">
        <thead style="display: flex; justify-content: space-between; background-color: rgb(217, 217, 217) !important; color: black !important; print-color-adjust: exact; text-align: center; border-bottom: 1px solid black;">
            <th style="border-left: 1px solid black;"></th>  
            <th style="" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">Size</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">Paper Material</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">Top or Bottom Cardboard</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 5%' : 'width: 8%')">J Slit</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">Handle Style</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 6%' : 'width: 8%')">Color Count</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">Colored Handle?</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 5%' : 'width: 8%')">Print %</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">Paper Weight</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 5%' : 'width: 8%')">GSM</th>
            <th style="border-right: 1px solid black;"></th>
            <th style="" :style="(!customQuote ? 'width: 10%' : 'width: 8%')">Inside Printing Sides</th>
            <th v-if="customQuote" style="border-right: 1px solid black;"></th>
            <th v-if="customQuote" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">Other Effects</th>
            <th v-if="!customQuote" style="border-right: 1px solid black;"></th>
            <th v-if="!customQuote" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">Items Per Case</th>
            <th v-if="!customQuote" style="border-right: 1px solid black;"></th>
            <th v-if="!customQuote" style=" width: 8%;">Price Per Case</th>
            <th v-if="!customQuote" style="border-right: 1px solid black;"></th>
            <th v-if="!customQuote" style=" width: 7%;">Total</th>
            <th style="border-right: 1px solid black;"></th>
        </thead>
        <tbody style="print-color-adjust: perfect;">
          <tr v-for="(itemArr, index2) in quantArr" style="display: flex; justify-content: space-between; text-align: center; border-bottom: 1px solid black;">
            <td style="border-left: 1px solid black;"></td>
            <td style="print-color-adjust: perfect;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">{{ itemArr.size_id.text }}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">{{itemArr.substrate_id.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">{{itemArr.cardboard.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 5%' : 'width: 8%')">{{itemArr.jslit.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">{{itemArr.handle_type_id.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 6%' : 'width: 8%')">{{itemArr.color_count.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">{{ itemArr.handle_color.text }}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 5%' : 'width: 8%')">{{itemArr.print_percentage.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">{{ (itemArr.gsm_id.value == 'custom') ? 'TBD' : (itemArr.gsm_id.text / 1.5).toFixed('2') }}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="" :style="(!customQuote ? 'width: 5%' : 'width: 8%')">{{itemArr.gsm_id.text}}</td>
            <td style="border-right: 1px solid black;"></td>
            <td style="print-color-adjust: exact;" :style="(!customQuote ? 'width: 10%' : 'width: 8%')">{{itemArr.inside_printing.text}}</td>
            <td v-if="customQuote" style="border-right: 1px solid black;"></td>
            <td v-if="customQuote" style="print-color-adjust: exact; overflow-x: scroll; white-space: nowrap;" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">{{itemArr.other_effects}}</td>
            <td v-if="!customQuote" style="border-right: 1px solid black;"></td>
            <td v-if="!customQuote" style="print-color-adjust: exact;" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">{{itemArr.amount_per_case}}</td>
            <td v-if="!customQuote" style="border-right: 1px solid black;"></td>
            <td v-if="!customQuote" style="width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">{{ (itemArr.price) ? '$' + Number(itemArr.price).toFixed('2') : '' }}</td>
            <td v-if="!customQuote" style="border-right: 1px solid black; background-color: rgb(146 208 80) !important; print-color-adjust: exact;"></td>
            <td v-if="!customQuote" style="width: 7%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">{{ (itemArr.price && itemArr.quantity.text && itemArr.quantity.text) ? '$' + (Number(itemArr.price) * ( itemArr.quantity.text / itemArr.amount_per_case)).toFixed('2') : '' }}</td>
            <td :style="(!customQuote) ? 'background-color: rgb(146 208 80) !important;' : ''" style="border-right: 1px solid black; print-color-adjust: exact;"></td>
          </tr>
        </tbody>
      </table>

      <div v-if="isMobile()" v-for="(itemArr, index2) in quantArr">
        <table  style="width: 100%; print-color-adjust: perfect;">
            <tr style="">
              <th style="border-top: 1px solid black; border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 10px; padding-right:5px;" :style="(!customQuote ? 'width: 12%' : 'width: 12%')">Size</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 10px; padding-right:5px; print-color-adjust: perfect;" :style="(!customQuote ? 'width: 12%' : 'width: 12%')">{{ itemArr.size_id.text }}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 9%' : 'width: 12%')">Paper Material</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 9%' : 'width: 12%')">{{itemArr.substrate_id.text}}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">Top or Bottom Cardboard</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">{{itemArr.cardboard.text}}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">J Slit</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">{{itemArr.jslit.text}}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">Handle Style</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">{{itemArr.handle_type_id.text}}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">Color Count</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">{{itemArr.color_count.text}}</td>
            </tr>
            
            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Colored Handle?</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{ itemArr.handle_color.text }}</td>
            </tr>
            

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Print %</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{itemArr.print_percentage.text}}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Paper Weight</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{ (itemArr.gsm_id.value == 'custom') ? 'TBD' : (itemArr.gsm_id.text / 1.5).toFixed('2') }}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 5%' : 'width: 5%')">GSM</th>
              <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 5%' : 'width: 5%')">{{itemArr.gsm_id.text}}</td>
            </tr>

            <tr style="">
              <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; " :style="(!customQuote ? 'width: 9%' : 'width: 11%')">Inside Printing Sides</th>
              <td style="border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px; print-color-adjust: exact;" :style="(!customQuote ? 'width: 9%' : 'width: 11%')">{{itemArr.inside_printing.text}}</td>
            </tr>

            <tr style="">
              <th v-if="customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">Other Effects</th>
               <td v-if="customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">{{ itemArr.other_effects }}</td>
             </tr>

             <tr style="">
              <th v-if="!customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">Items Per Case</th>
               <td v-if="!customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">{{ itemArr.amount_per_case }}</td>
             </tr>

             <tr style="">
              <th v-if="!customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">Price Per Case</th>
               <td v-if="!customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">${{ Number(itemArr.price).toFixed('2')  }}</td>
             </tr>

            <tr style="">
              <th v-if="!customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 9%;">Total</th>
              <td v-if="!customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">{{ (Number(itemArr.price) * ( itemArr.quantity.text / itemArr.amount_per_case)).toFixed('2') }}</td>
            </tr>
        </table>
      </div>
    </div>

    <div v-if="otherFees.length" style="margin-bottom: 50px;"></div>

    <table v-if="otherFees.length" style="width: 100%;">
      <thead style="background-color: black !important; color: white !important; print-color-adjust: exact; display: flex; justify-content: space-around; border: 1px solid black;">
          <th style="padding-left: 5px; padding-right:5px; width: 91%;">OTHER FEES</th>
          <span style="border-right: 1px solid black;"></span>
          <th style="padding-left: 5px; padding-right:5px; width: 9%; text-align: center;">AMOUNT</th>
      </thead>
      <tbody>
        <tr style="display: flex; border-bottom: 1px solid black; border-right: 1px solid black; border-left: 1px solid black;">
          <td style="padding-left: 12px; padding-right:5px; width: 91%;">Description</td>
          <span style="border-right: 1px solid black;"></span>
          <td style="padding-left: 5px; padding-right:5px; width: 9%; text-align: center; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">$0.00</td>
        </tr>
        <tr style="display: flex; border-bottom: 1px solid black; border-right: 1px solid black; border-left: 1px solid black;">
          <td style="padding-left: 12px; padding-right:5px; width: 91%;">Description</td>
          <span style="border-right: 1px solid black;"></span>
          <td style="padding-left: 5px; padding-right:5px; width: 9%; text-align: center; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">$0.00</td>
        </tr>
      </tbody>
    </table>

    <div style="margin-bottom: 50px;"></div>

    <div style="width: 600px; background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">TERMS AND CONDITIONS</div>
    <br>
    <ol style="padding-left: 15px;">
      <li>Net 30</li>
      <li>Lead time options: With a sample: 30 days for a sample after artwork approval and 90 days </li>
      <li>Artwork and Pre Production sample need to be approved within 3 days of delivery.</li>
      <li>10%+- Tolerance</li>
      <li>Every order includes 1 hour of free artwork design. After that a fee of 50 per hour of designing apply.</li>
      <li>Samples are based on approved artwork/PMS colors. If matching an existing sample is needed, a $250 fee will apply.</li>
      <li>To avoid confusion we will not accept an order without the art to make the artwork is provided.</li>
      <li>Every PO needs to have the Bag/Box size and Case pack.</li>
    </ol>

    <div style="margin-bottom: 50px;"></div>

    <div style="width: 600px; background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">ARTWORK REQUIREMENTS</div>
    <br>
    <div style="padding-bottom: 5px; font-weight: bold;">FILE FORMATS ACCEPTED:</div>
    <div>We accept the following file formats PDF / Illustrator / InDesign - convert all fonts to outlines.</div>
    <div>Please ensure the file sent is an editable file and not flattened. We must be able to separate the backgrounds, text and logos from each other.</div>
    <div style="padding-bottom: 5px; padding-top: 5px; font-weight: bold;">FONTS:</div>
    <div>Include all fonts you have used in the file.</div>
    <div style="padding-bottom: 5px; padding-top: 5px; font-weight: bold;">COLORS:</div>
    <div>Include the details of all colors used in the file and especially if you have specific brand colors that need to be used.</div>
    <div>CMYK colors and Pantone Colors and NOT RGB.</div>
    <div style="padding-bottom: 5px; padding-top: 5px; font-weight: bold;">IMAGES / LOGOS:</div>
    <div>Please only include vector based logos and images.</div>

    <div style="margin-bottom: 50px;"></div>
  </div>
  <br><br>
  <p style="text-align:center; font-size: 20px; color: black; print-color-adjust: exact;"><i>Thank You For Your Business!</i></p>
  
  <div style="text-align: center; align-content: center; align-items: center" class="noprint">
    <button @click="generateReport()" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:40px; padding-left:40px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;;">
      Print Quote
    </button>
  </div>
    
    <VueHtml2pdf
      element="#html-to-pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="myPDF"
      :pdf-quality="2"
      :manual-pagination="false"
      :manual="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2Pdf"
      id="html-to-pdf"
    >
      <section slot="pdf-content">
        <div id="pdf-container" style="margin: 10px;">

          <div style="margin-top: 25px;">
              <img :src="this.logo" alt="logo" height="60">
              <span style="padding-left: 10px; font-size:23px; color:black;">Flexo Craft Prints</span>
              <br v-if="isMobile()">
              <br v-if="isMobile()">
              <div :style="(isMobile()) ? '' : 'display: flex; justify-content: space-between;' " style="">
                <div>
                  <p style="line-height: 4px; margin-top: 10px;">1000 First St</p>
                  <p style="line-height: 4px;">Harrison, NJ 07029</p>
                  <p style="line-height: 4px;">FlexoCraft.com</p>
                  <p style="line-height: 4px;">Phone: 800-785-2737</p>
                  <p style="line-height: 4px;">Email: info@flexcraft.com</p>
                </div>

                <br v-if="isMobile()">

                <div style="border: 1px solid black; padding-left: 5px; padding-right: 5px;">
                  <p style="line-height: 2px; margin-top: 10px; padding-top: 2px; padding-bottom: 10px; border-bottom: 1px solid black;">DATE: {{ currentDate }}</p>
                  <p style="line-height: 2px; padding-bottom: 10px; border-bottom: 1px solid black;">QUOTE #: {{ quoteId }}</p>
                  <p style="line-height: 2px; padding-bottom: 12px; border-bottom: 1px solid black;">VALID UNTIL: {{ validUntil }}</p>
                  <p style="line-height: 2px; padding-bottom: 12px; border-bottom: 1px solid black;">FOB: NJ/CA</p>
                  <p style="line-height: 0px;">CASE PACK: {{ casePackAmount ? casePackAmount : '' }}</p>
                </div>
              </div>

              <br v-if="isMobile()">
              <br v-if="isMobile()">

              <div :style="(isMobile()) ? '' : 'width: 400px;' " style="background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">CUSTOMER</div>
              <p style="font-size:18px; color: black; padding-top: 2px;">{{ userData.fullName }}</p>

              <div style="margin-bottom: 25px;"></div>

              <div :style="(isMobile()) ? '' : 'width: 400px;' " style="background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">PRINT NAME</div>
              <p style="font-size:18px; color: black; padding-top: 2px;">{{ printName }}</p>

              <div style="margin-bottom: 25px;"></div>
            <!--</div>-->
            <br>

            <div v-if="customQuote" style="font-size: 20px; text-align: center; color: green;">
              <i><b>Thank you for your quote. A quote representative will reach out with a quote within 48 hours.</b></i>
            </div>

            <br><br><br>
            <!--
            <div style="color: white; background-color: black;">
            <p v-if="this.quote" style="font-weight: bold; font-size: 50px; padding-top: 30px;">${{ (this.quote * this.selectedQuantity).toLocaleString('en-US') }}</p>
            <p v-else style="font-weight: bold; font-size: 50px; padding-top: 30px;">Thank You!</p>
            <p v-if="this.quote" style="padding-top:5px;">${{ this.quote }} per piece</p>
            <p v-else style="padding-top:5px;">Your quote will be emailed to you shortly.</p>
            </div>
            -->
            <div v-for="(quantArr, index) in displayItems">
              <div style="background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold; margin-top: 25px;">
                QUANTITY {{ index }}
              </div>
              <table v-if="!isMobile()" style="width: 100%;">
                <thead style="display: flex; justify-content: space-between; background-color: rgb(217, 217, 217) !important; color: black !important; print-color-adjust: exact; text-align: center; border-bottom: 1px solid black; font-size: 10px;">
                    <th style="border-left: 1px solid black;"></th>  
                    <th style="" :style="(!customQuote ? 'width: 8%' : 'width: 12%')">Size</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 8%' : 'width: 9%')">Paper Material</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 9%' : 'width: 12%')">Top or Bottom Cardboard</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 5%' : 'width: 7%')">J Slit</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">Handle Style</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 6%' : 'width: 7%')">Color Count</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Colored Handle?</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 5%' : 'width: 6%')">Print %</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">Paper Weight</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 5%' : 'width: 6%')">GSM</th>
                    <th style="border-right: 1px solid black;"></th>
                    <th style="" :style="(!customQuote ? 'width: 10%' : 'width: 8%')">Inside Printing Sides</th>
                    <th v-if="customQuote" style="border-right: 1px solid black;"></th>
                    <th v-if="customQuote" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">Other Effects</th>
                    <th v-if="!customQuote" style="border-right: 1px solid black;"></th>
                    <th v-if="!customQuote" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">Items Per Case</th>
                    <th v-if="!customQuote" style="border-right: 1px solid black;"></th>
                    <th v-if="!customQuote" style=" width: 8%;">Price Per Case</th>
                    <th v-if="!customQuote" style="border-right: 1px solid black;"></th>
                    <th v-if="!customQuote" style=" width: 7%;">Total</th>
                    <th style="border-right: 1px solid black;"></th>
                </thead>
                <tbody style="print-color-adjust: perfect;">
                  <tr v-for="(itemArr, index2) in quantArr" style="display: flex; justify-content: space-between; text-align: center; border-bottom: 1px solid black; font-size: 11px;">
                    <td style="border-left: 1px solid black;"></td>
                    <td style="print-color-adjust: perfect;" :style="(!customQuote ? 'width: 8%' : 'width: 12%')">{{ (itemArr.custom_size) ? itemArr.custom_size : itemArr.size_id.text }}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 8%' : 'width: 9%')">{{itemArr.substrate_id.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 9%' : 'width: 12%')">{{itemArr.cardboard.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 5%' : 'width: 7%')">{{itemArr.jslit.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">{{itemArr.handle_type_id.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 6%' : 'width: 7%')">{{itemArr.color_count.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{ itemArr.handle_color.text }}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 5%' : 'width: 6%')">{{itemArr.print_percentage.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">{{ (itemArr.gsm_id.text / 1.5).toFixed('2') }}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="" :style="(!customQuote ? 'width: 5%' : 'width: 6%')">{{itemArr.gsm_id.text}}</td>
                    <td style="border-right: 1px solid black;"></td>
                    <td style="print-color-adjust: exact;" :style="(!customQuote ? 'width: 10%' : 'width: 8%')">{{itemArr.inside_printing.text}}</td>
                    <td v-if="customQuote" style="border-right: 1px solid black;"></td>
                    <td v-if="customQuote" style="print-color-adjust: exact; overflow-x: scroll; white-space: nowrap;" :style="(!customQuote ? 'width: 7%' : 'width: 8%')">{{itemArr.other_effects}}</td>
                    <td v-if="!customQuote" style="border-right: 1px solid black;"></td>
                    <td v-if="!customQuote" style="print-color-adjust: exact; overflow-x: scroll; white-space: nowrap;" :style="(!customQuote ? 'width: 8%' : 'width: 8%')">{{itemArr.amount_per_case}}</td>
                    <td v-if="!customQuote" style="border-right: 1px solid black;"></td>
                    <td v-if="!customQuote" style="width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">${{ Number(itemArr.price).toFixed('2') }}</td>
                    <td v-if="!customQuote" style="border-right: 1px solid black; background-color: rgb(146 208 80) !important; print-color-adjust: exact;"></td>
                    <td v-if="!customQuote" style="width: 7%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">${{ (Number(itemArr.price) * ( itemArr.quantity.text / itemArr.amount_per_case)).toFixed('2') }}</td>
                    <td style="border-right: 1px solid black; background-color: rgb(146 208 80) !important; print-color-adjust: exact;"></td>
                  </tr>
                </tbody>
              </table>

              <div v-if="isMobile()" v-for="(itemArr, index2) in quantArr">
                <table style="width: 100%; print-color-adjust: perfect;">
                    <tr style="">
                      <th style="border-top: 1px solid black; border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 10px; padding-right:5px;" :style="(!customQuote ? 'width: 12%' : 'width: 12%')">Size</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 10px; padding-right:5px; print-color-adjust: perfect;" :style="(!customQuote ? 'width: 12%' : 'width: 12%')">{{ itemArr.size_id }}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 9%' : 'width: 12%')">Paper Material</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 9%' : 'width: 12%')">{{itemArr.substrate_id.text}}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">Top or Bottom Cardboard</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">{{itemArr.cardboard.text}}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">J Slit</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 11%' : 'width: 13%')">{{itemArr.jslit.text}}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">Handle Style</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">{{itemArr.handle_type_id.text}}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">Color Count</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 8%' : 'width: 10%')">{{itemArr.color_count.text}}</td>
                    </tr>
                    
                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Colored Handle?</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{ itemArr.handle_color.text }}</td>
                    </tr>
                    

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Print %</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{itemArr.print_percentage.text}}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">Paper Weight</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 7%' : 'width: 9%')">{{ (itemArr.gsm_id.text / 1.5).toFixed('2') }}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 5%' : 'width: 5%')">GSM</th>
                      <td style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px;" :style="(!customQuote ? 'width: 5%' : 'width: 5%')">{{itemArr.gsm_id.text}}</td>
                    </tr>

                    <tr style="">
                      <th style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; " :style="(!customQuote ? 'width: 9%' : 'width: 11%')">Inside Printing Sides</th>
                      <td style="border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black; padding-left: 5px; padding-right:5px; print-color-adjust: exact;" :style="(!customQuote ? 'width: 9%' : 'width: 11%')">{{itemArr.inside_printing.text}}</td>
                    </tr>

                    <tr style="">
                      <th v-if="customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">Other Effects</th>
                       <td v-if="customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">{{ itemArr.other_effects }}</td>
                     </tr>

                     <tr style="">
                      <th v-if="!customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">Items Per Case</th>
                       <td v-if="!customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">${{ itemArr.amount_per_case }}</td>
                     </tr>

                     <tr style="">
                      <th v-if="!customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%;">Price Per Case</th>
                       <td v-if="!customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">${{ itemArr.price }}</td>
                     </tr>

                    <tr style="">
                      <th v-if="!customQuote" style="border-right: 1px solid black; border-left: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-right:5px; width: 9%;">Total</th>
                      <td v-if="!customQuote" style="border-bottom: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; border-left: 1px solid black; padding-left: 5px; padding-right:5px; width: 8%; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">{{ (Number(itemArr.price) * ( itemArr.quantity.text / itemArr.amount_per_case)).toFixed('2') }}</td>
                    </tr>
                </table>
              </div>
            </div>

            <div v-if="otherFees.length" style="margin-bottom: 50px;"></div>

            <table v-if="otherFees.length" style="width: 100%;">
              <thead style="background-color: black !important; color: white !important; print-color-adjust: exact; display: flex; justify-content: space-around; border: 1px solid black;">
                  <th style="padding-left: 5px; padding-right:5px; width: 91%;">OTHER FEES</th>
                  <span style="border-right: 1px solid black;"></span>
                  <th style="padding-left: 5px; padding-right:5px; width: 9%; text-align: center;">AMOUNT</th>
              </thead>
              <tbody>
                <tr style="display: flex; border-bottom: 1px solid black; border-right: 1px solid black; border-left: 1px solid black;">
                  <td style="padding-left: 12px; padding-right:5px; width: 91%;">Description</td>
                  <span style="border-right: 1px solid black;"></span>
                  <td style="padding-left: 5px; padding-right:5px; width: 9%; text-align: center; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">$0.00</td>
                </tr>
                <tr style="display: flex; border-bottom: 1px solid black; border-right: 1px solid black; border-left: 1px solid black;">
                  <td style="padding-left: 12px; padding-right:5px; width: 91%;">Description</td>
                  <span style="border-right: 1px solid black;"></span>
                  <td style="padding-left: 5px; padding-right:5px; width: 9%; text-align: center; background-color: rgb(146 208 80) !important; print-color-adjust: exact;">$0.00</td>
                </tr>
              </tbody>
            </table>

            <div style="margin-bottom: 50px;"></div>

            <div style="width: 600px; background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">TERMS AND CONDITIONS</div>
            <br>
            <ol style="padding-left: 15px;">
              <li>Net 30</li>
              <li>Lead time options: With a sample: 30 days for a sample after artwork approval and 90 days </li>
              <li>Artwork and Pre Production sample need to be approved within 3 days of delivery.</li>
              <li>10%+- Tolerance</li>
              <li>Every order includes 1 hour of free artwork design. After that a fee of 50 per hour of designing apply.</li>
              <li>Samples are based on approved artwork/PMS colors. If matching an existing sample is needed, a $250 fee will apply.</li>
              <li>To avoid confusion we will not accept an order without the art to make the artwork is provided.</li>
              <li>Every PO needs to have the Bag/Box size and Case pack.</li>
            </ol>

            <div style="margin-bottom: 50px;"></div>

            <div style="width: 600px; background-color: black !important; color: white !important; print-color-adjust: exact; padding: 2px; padding-left: 5px; font-weight:bold;">ARTWORK REQUIREMENTS</div>
            <br>
            <div style="padding-bottom: 5px; font-weight: bold;">FILE FORMATS ACCEPTED:</div>
            <div>We accept the following file formats PDF / Illustrator / InDesign - convert all fonts to outlines.</div>
            <div>Please ensure the file sent is an editable file and not flattened. We must be able to separate the backgrounds, text and logos from each other.</div>
            <div style="padding-bottom: 5px; padding-top: 5px; font-weight: bold;">FONTS:</div>
            <div>Include all fonts you have used in the file.</div>
            <div style="padding-bottom: 5px; padding-top: 5px; font-weight: bold;">COLORS:</div>
            <div>Include the details of all colors used in the file and especially if you have specific brand colors that need to be used.</div>
            <div>CMYK colors and Pantone Colors and NOT RGB.</div>
            <div style="padding-bottom: 5px; padding-top: 5px; font-weight: bold;">IMAGES / LOGOS:</div>
            <div>Please only include vector based logos and images.</div>

            <div style="margin-bottom: 50px;"></div>
          </div>
          <br><br>
          <p style="text-align:center; font-size: 20px; color: black; print-color-adjust: exact;"><i>Thank You For Your Business!</i></p>

        </div>
      </section>
    </VueHtml2pdf>
  
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from 'axios';
import html2pdf from "html2pdf.js";
import ModalIdle from "@/views/components/ModalIdle.vue"
import VueHtml2pdf from 'vue-html2pdf'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  props: ['displayItems', 'printName', 'selectedSize', 'selectedSubstrate', 'selectedGsm', 'selectedHandle', 'selectedFinish', 'selectedCardboard', 'selectedColorCount', 'selectedPrint', 'selectedIp', 'selectedQuantity', 'otherEffects', 'quote', 'quoteId', 'casePackAmount', 'otherFees', 'selectedSide', 'selectedWeight', 'customSize', 'userData', 'selectedHandleColor', 'selectedJslit', 'customQuote'],
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ModalIdle,
    VueHtml2pdf
  },
  data() {
    return {
      sizeId: 2,
      gsmId: 9,
      printPercentage: 75,
      colorCount: 1,
      substrateId: 1,
      handleTypeId: 1,
      finishId: 1,
      cardboard: 'TOP',
      insidePrinting: 0,
      apiInfo: null,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      logo: require('@/assets/images/logo/favicon.png'),
      required,
      email,
      quoteGenerated: false,
      prices: {},
      insertStatus: '',
      quote_data: [],
      showPrint: true,
    }
  },
  methods: {
    generateReport() {
      //this.$refs.html2Pdf.generatePdf()

      var element = document.getElementById('pdf-container')
      //html2pdf(element)
      //html2pdf().from(element).save()
      html2pdf().from(element).toPdf().get('pdf').then(function (pdf) {
        window.open(pdf.output('bloburl'), '_blank');
      });
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    logoUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.logo = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.logo
    },
    print(){
      this.showPrint = false;
      //html2pdf(document.getElementById('element-to-convert'));
      window.print()
    },
    
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle
    },
    currentDate() {
      var date = new Date();
      var dd = String(date.getDate()).padStart(2, '0')
      var mm = String(date.getMonth() + 1).padStart(2, '0')
      var yyyy = date.getFullYear()
      return mm + '/' + dd + '/' + yyyy;
    },
    validUntil() {
      var date = new Date();
      var dd = String(date.getDate()).padStart(2, '0')
      var mm = String(date.getMonth() + 2).padStart(2, '0')
      var yyyy = date.getFullYear()
      return mm + '/' + dd + '/' + yyyy;
    },
    quotePerItem() {
      return (this.quote) ? '$' + this.quote.toFixed('4') : ''
    },
    pricePerCase() {
      return (this.quote) ? '$' + (this.quote * this.selectedQuantity).toFixed('2') : ''
    }
  }
}
</script>
<style>
  @media print {
     .noprint {
        visibility: hidden;
     }
  }

  @page { size: auto;  margin: 0mm; }
</style>
